// src/auth/UnauthorizedPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ArrowLeft, HelpCircle } from 'lucide-react';
import { useAuth } from './SupabaseAuthProvider';

const UnauthorizedPage = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="p-8">
          <div className="flex items-center justify-center mb-6">
            <div className="bg-yellow-100 p-3 rounded-full">
              <AlertTriangle className="h-10 w-10 text-yellow-600" />
            </div>
          </div>

          <h1 className="text-2xl font-bold text-center text-gray-900 mb-2">
            Access Denied
          </h1>

          <p className="text-center text-gray-600 mb-6">
            You don't have permission to access this area. This section requires
            administrator privileges.
          </p>

          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-700">
              <strong>Current user:</strong> {user?.email || 'Not signed in'}
            </p>
            <p className="text-sm text-gray-700 mt-1">
              <strong>Required role:</strong> Administrator
            </p>
          </div>

          <div className="space-y-4">
            <Link
              to="/app/dashboard"
              className="w-full flex justify-center items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Return to Dashboard
            </Link>

            <Link
              to="/contact"
              className="w-full flex justify-center items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              <HelpCircle className="mr-2 h-4 w-4" />
              Contact Support
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
